export const IS_FORM_VISIBLE = 'isFormVisible';

export const STATUS_NO_ACCESS = 'NoAccess';
export const STATUS_NEW_FIELDS_ADDED = 'NewFieldsAdded';
export const STATUS_ALREADY_REGISTERED = 'AlreadyRegistered';
export const STATUS_ENTER_EMAIL = 'EnterEmail';
export const STATUS_WRONG_FORMAT = 'WrongFormat';
export const STATUS_NOT_SPECIFIED = 'EmailNotSpacified';
export const STATUS_USE_CORPORATE_MAIL = 'UseCorporateMail';

export const FIELD_TYPE = 'type';
export const FIELD_READONLY = 'readOnly';
export const FIELD_VALUE = 'value';

export const FIELD_NAME = 'name';
export const FIELD_TERMS_AGREE = 'termsAgree';
export const FIELD_EMAIL = 'email';
export const FIELD_TEL = 'tel';
export const FIELD_PARTICIPATION_TYPE = 'participationType';
export const FIELD_CUSTOM_AGREE = 'customAgree';
export const FIELD_KONTUR_FOCUS = 'konturFocus';
export const FIELD_PHOTO = 'photo';
export const FIELD_DISCLAIMER = 'disclaimer';

export const TYPE_HYBRID = 'hybrid';

export const REQUIREMENT_FORMAT = 'format';
export const REQUIREMENT_SIZE = 'size';
export const REQUIREMENT_WEIGHT = 'weight';
export const REQUIREMENT_FACE = 'face';
export const REQUIREMENT_ACCESSORIES = 'accessories';

export const ICON_SUCCESS = 'SuccessIcon';
export const ICON_ERROR = 'ErrorIcon';
export const ICON_CALENDAR = 'CalendarIcon';
export const ICON_ADD = 'AddIcon';
export const ICON_TAKE_PHOTO = 'TakePhotoIcon';
export const ICON_BACK = 'BackIcon';
export const ICON_CLOSE = 'CloseIcon';
export const ICON_WARNING = 'WarningIcon';
export const ICON_EDIT = 'EditIcon';
export const ICON_PLUS = 'PlusIcon';
export const ICON_MINUS = 'MinusIcon';

export const PHOTO_ERROR_FORMAT = 'formatError';
export const PHOTO_ERROR_SIZE = 'maxSize';

export const WIDGET_SECOND_SCREEN_TITLE_RU = 'secondScreenTitleRu';
export const WIDGET_SECOND_SCREEN_TITLE_EN = 'secondScreenTitleEn';
export const WIDGET_SECOND_SCREEN_TEXT_RU = 'secondScreenTextRu';
export const WIDGET_SECOND_SCREEN_TEXT_EN = 'secondScreenTextEn';
export const WIDGET_FIRST_SCREEN_BUTTON_TEXT_RU = 'firstScreenButtonTextRu';
export const WIDGET_FIRST_SCREEN_BUTTON_TEXT_EN = 'firstScreenButtonTextEn';
export const WIDGET_FIRST_SCREEN_TITLE_RU = 'firstScreenTitleRu';
export const WIDGET_FIRST_SCREEN_TITLE_EN = 'firstScreenTitleEn';
export const WIDGET_FIRST_SCREEN_SUBTITLE_RU = 'firstScreenSubtitleRu';
export const WIDGET_FIRST_SCREEN_SUBTITLE_EN = 'firstScreenSubtitleEn';

export const PARAM_LANG = 'lang';
